import { useLocation } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation, Pagination, Autoplay, A11y } from "swiper";
import { useState } from "react";
import "swiper/swiper-bundle.css";

SwiperCore.use([Navigation, Pagination, Autoplay, A11y]);

const TestimonialSection = ({ testimonials }) => {
  const location = useLocation();
  const isSpecialtiesPage = location.pathname.toLowerCase().includes("specialties");

  const heading = testimonials?.heading || "As told by our Patients";
  const testimonialItems = testimonials?.items || [];

  const [popupContent, setPopupContent] = useState(null);

  if (!testimonialItems.length) return null;

  const truncateText = (text, limit = 350) => {
    if (!text) return "";
    return text.length > limit ? text.slice(0, limit) + "..." : text;
  };

  return (
    <>
      <section className="testimonial-section">
        <div className="container position-relative">
          <h2 className="section-title">
            {isSpecialtiesPage ? heading : "As told by our Patients"}
          </h2>
          <p className="section-subtitle">Patients Corner</p>

          <Swiper
            navigation={{ prevEl: ".slick-prev", nextEl: ".slick-next" }}
            pagination={{ clickable: true }}
            autoplay={{ delay: 4000, disableOnInteraction: false }}
            loop
            spaceBetween={50}
            slidesPerView={3}
            breakpoints={{
              992: { slidesPerView: 3 },
              768: { slidesPerView: 2 },
              0: { slidesPerView: 1 },
            }}
            className="testimonial-wrapper"
          >
            {testimonialItems.map((item, index) => (
              <SwiperSlide key={index} className="ps-0 ps-md-3">
                <div className="testimonial-card">
                  {item.video_image_url && (
                    <div className="testimonial-video-container">
                      <iframe
                        src={item.video_image_url}
                        title="Video"
                        allowFullScreen
                      />
                    </div>
                  )}

                  <h3>{item.name}</h3>
                  <div className="stars">{"★".repeat(item.stars || 5)}</div>

                  <p>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: truncateText(item.content),
                      }}
                    />
                    {item.content?.length > 350 && (
                      <span
                        className="read-more"
                        onClick={() => setPopupContent(item.content)}
                      >
                        {" "}Read more
                      </span>
                    )}
                  </p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          <button className="slick-prev">
            <i className="fa-solid fa-chevron-left"></i>
          </button>
          <button className="slick-next">
            <i className="fa-solid fa-chevron-right"></i>
          </button>
        </div>
      </section>

      {/* POPUP */}
      {popupContent && (
        <div className="testimonial-popup">
          <div className="popup-content">
            <button
              className="close-btn"
              onClick={() => setPopupContent(null)}
            >
              ✕
            </button>

            <div
              dangerouslySetInnerHTML={{
                __html: popupContent,
              }}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default TestimonialSection;
